import fetcher from '@/utils/fetcher';

const postResetPasswordAfterVerifyEmail = async (password: string) => {
  try {
    const res = await fetcher.post('/api/auth/reset-password', {
      data: { password },
    });
    return res.status === 200;
  } catch (e) {
    return false;
  }
};

export default postResetPasswordAfterVerifyEmail;
